/** Angular */
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
/** Services */
import { BydAbstractService, BydConfigService } from '@sixense/byd-core-service';
import { BydFeatureFlagService } from '@sixense/byd-feature-flags';
import { BydRhsHeadersService } from './byd-rhs-headers.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BydRhsAbstractService extends BydAbstractService {
  /**
   * Implement inherited abstract member 'baseUrl' from BydAbstractService
   */
  public baseUrl: string;

  /**
   * The headers object used in `BydAbstractService` to perform the HTTP request.
   */
  protected headers: HttpHeaders;

  /**
   * The headers service.
   */
  protected bydRhsHeadersService: BydRhsHeadersService;

  /**
   * The feature flag service.
   */
  protected bydFeatureFlagService: BydFeatureFlagService;

  /**
   * The abstract endpoint path.
   */
  public abstract path: string;

  /**
   * @param injector creates a service injector instance
   */
  constructor(protected injector: Injector) {
    super(injector?.get(HttpClient), injector?.get(BydConfigService));
    this.bydRhsHeadersService = injector?.get(BydRhsHeadersService);
    this.bydFeatureFlagService = injector?.get(BydFeatureFlagService);
    this.baseUrl = this.bydConfigService?.injectedApiToken.apiUrl;
    this.headers = new HttpHeaders().set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
  }

  public abstract createNewInstance(jsonObject);
}
